window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Cart Ajax Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts to break out Cart Ajax Functions
 *
 * @namespace cartAjax
 */

slate.cartAjax = (function() {
  // Private Functions
  /**
   * Trigger a custom event
   * Watch "cartUpdated" to be notified when the browser has recieved a new cart object
   */
  function cartUpdatedTrigger() {
    $.event.trigger({
      type: "cartUpdated",
      message: "cartUpdated fired.",
      time: new Date()
    });
  }

  // Public Methods and attributes
  var cart = {};

  /**
   * Add a new product to the cart
   * @param {int} variant
   * @param {int} qty
   * @returns {obj} jqXHR object
   */
  function addToCart(variant, qty) {
    var addItem = $.post(
      "/cart/add.js",
      { quantity: qty, id: variant },
      function(data) {
        // console.log("addToCart data response");
      },
      "json"
    );

    addItem.done(function() {
      slate.cartAjax.getCart();
    });

    addItem.fail(function(error) {
      console.log("addToCart error");
      console.log(error);
    });

    return addItem;
  }

  /**
   * Add a new product to the cart
   * @param {int} variant product variant id
   * @param {int} qty number of products
   * @returns {obj} jqXHR object
   */
  function changeItemByID(variant, qty) {
    var changeItem = $.post(
      "/cart/change.js",
      { quantity: qty, id: variant },
      function(data) {
        slate.cartAjax.cart = data;
      },
      "json"
    );

    changeItem.done(function() {
      cartUpdatedTrigger();
    });

    changeItem.fail(function(error) {
      console.log("changeItem error");
      console.log(error);
    });

    return changeItem;
  }

  /**
   * @returns {obj} jqXHR object
   */
  function getCart() {
    var getCartJSON = $.getJSON(
      "/cart.js",
      function(data) {
        slate.cartAjax.cart = data;
      },
      "json"
    );

    getCartJSON.done(function() {
      cartUpdatedTrigger();
    });
    getCartJSON.fail(function(error) {
      console.log(error);
    });

    return getCartJSON;
  }

  return {
    addToCart: addToCart,
    changeItemByID: changeItemByID,
    getCart: getCart
  };
})();

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value;
  },

  viewportWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
  viewportHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),

  setViewportSize: function () {
    this.viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    this.viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  },

  /**
   * Check if the browser supports SVG
   */
  supportsSVG: function () {
    return document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1");
  },

  /**
   * Check if the browser supports background-blend-mode
   */
  supportsBackgroundBlendMode: function () {
    return !!window.getComputedStyle(document.body).backgroundBlendMode;
  },

  /**
   * debounce function
   * for stopping a function from running if it has already ran recently
   *
   * @param {function} func - function to be debounced
   * @param {int} wait - number of milliseconds to to wait
   * @param {bool} immediate - if function should be called first before waiting
   */
  debounce: function (func, wait, immediate) {
    wait = wait || 200;
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      }, wait);
      if (immediate && !timeout) func.apply(context, args);
    };
  },

  /**
   * Determine which transition end event the browser uses
   *
   * @returns {string} - returns the transition end event to use
   */
  whichTransitionEvent: function () {
    var el = document.createElement('fakeelement'),
      transitions = {
        'transition': 'transitionend',
        'OTransition': 'oTransitionEnd',
        'MozTransition': 'transitionend',
        'WebkitTransition': 'webkitTransitionEnd'
      };

    for (var t in transitions) {
      if (el.style[t] !== undefined) {
        return transitions[t];
      }
    }
  },

  /**
   * Wrapper for debouncing viewport resize events
   *
   * @param {function} callback - the function you want to call on viewport resize
   */
  onResizeDebounce: function (callback) {
    callback();

    $(window).on('resize', slate.utils.debounce(function () {
      callback();
    }, 200));
  },

  /**
   * Checks if an element exists
   * Returns true or false
   *
   * @param {object} el - Dom Element
   * @returns {bool} - Returns the resolved value
   */
  elementExists: function (el) {
    if (typeof (el) !== 'undefined' && el !== null) {
      return true;
    }
    return false;
  },

  queryParams: {},

  getQueryParams: function () {
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          this.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
  },

  /**
   * Sets a new browser cookie with a specified name, value, and expiry date
   * @param {Object} new_cookie
   * new_cookie object example:
   * {
   *   name: "my cookie",
   *	 value: true,
   *   expires: 365
   * }
   */
  setCookie: function (new_cookie) {
    var todays_date = new Date();
    todays_date.setTime(
      todays_date.getTime() + new_cookie.expires * 24 * 60 * 60 * 1000
    );
    var expires = "expires=" + todays_date.toUTCString();
    document.cookie =
      new_cookie.name + "=" + new_cookie.value + ";" + expires + ";path=/";
  },

  /**
   * Returns the value of a given cookie
   * - or false if cookie doesn't exist
   * @param {String} cookie_name
   * @returns {Boolean}
   */
  getCookie: function (cookie_name) {
    cookie_name += "=";
    var cookie_value = false;

    var decoded_cookie = decodeURIComponent(document.cookie);
    var cookie_start = decoded_cookie.indexOf(cookie_name);
    var cookie_end = decoded_cookie.indexOf(";", cookie_start + 1);
    // the cookie value might not end in a semicolon
    // - if it doesn't then just end the string at the end of the cookie string
    cookie_end = cookie_end > 1 ? cookie_end : decoded_cookie.length;

    // only get the cookie value if the cookie is found in the users cookies string
    if (cookie_start >= 0 && cookie_end <= decoded_cookie.length) {
      cookie_value = decoded_cookie.substring(
        cookie_start + cookie_name.length,
        cookie_end
      );
    }

    // return the value of the given cookie
    // - if the cookie value string is "true" or "false" then change cookie_value to bolean value
    if (cookie_value === "true") {
      cookie_value = true;
    } else if (cookie_value === "false") {
      cookie_value = false;
    }

    return cookie_value;
  },

  /*
   * Deletes the cookie with the name given as a param
   * Uses the setCookie method to set the cookie to be expired
   * @param {String} cookie_name
   */
  deleteCookie: function (cookie_name) {
    var cookie_to_delete = {
      name: cookie_name,
      value: "",
      expires: -365
    };

    this.setCookie(cookie_to_delete);
  },

  domReady: function(fnc) {
    document.addEventListener('DOMContentLoaded', fnc)
  }
};
/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="youtube-nocookie.com/embed"], .rte iframe[src*="player.vimeo"], .product-long-description iframe[src*="youtube.com/embed"], .product-long-description iframe[src*="youtube-nocookie.com/embed"], .product-long-description iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
// header.js

// window.theme = window.theme || {}
// const theme = window.theme

window.as = window.as || {};
var AS = window.as;

window.theme.Header = {};
var Header = window.theme.Header;

// Setup ==============================================================

Header.currentScrollY = 0;
Header.scrollHistory = [];

// Setup ==============================================================

Header.onPageScroll = function() {
  Header.currentScrollY = window.pageYOffset;
  Header.scrollHistory.unshift(window.pageYOffset);
  if (Header.scrollHistory.length > 5) { Header.scrollHistory.length = 5; }

  if (Header.currentScrollY <= 15) {
    document.body.classList.remove('page-is-scrolled');
  } else {
    document.body.classList.add('page-is-scrolled');
  }

  if (Header.currentScrollY > 100) {
    var scrollDiff = Header.scrollHistory[0] - Header.scrollHistory[Header.scrollHistory.length-1];
  
    if (scrollDiff <= -40) {
      document.body.classList.remove('header-fade-out');
    } else if (scrollDiff >= 40) {
      document.body.classList.add('header-fade-out');
    }
  } else {
    document.body.classList.remove('header-fade-out');
  }
}

Header.setupFrontPageScroll = function() {
  // if (!document.body.classList.contains('template-index')) { return }

  // to deal with loading the frontpage when partly scrolled
  Header.onPageScroll();

  // add the scroll event for all other times
  document.addEventListener('scroll', Header.onPageScroll, false);
}

slate.utils.domReady(Header.setupFrontPageScroll)

Header.toggleOpenNavClass = function(evt) {
  if (evt) { evt.preventDefault(); }
  document.body.classList.toggle('nav-is-open');
}

Header.addOpenNavClass = function(evt) {
  if (evt) { evt.preventDefault(); }
  document.body.classList.add('nav-is-open');
}

Header.closeSidebar = function(evt) {
  if (evt) { evt.preventDefault(); }
  document.body.classList.remove('nav-is-open');
}

Header.setupMobileMenuToggle = function() {
  document.querySelectorAll('.js-nav-toggle').forEach(function(el) {
    el.addEventListener('click', Header.toggleOpenNavClass);
  })
}

slate.utils.domReady(Header.setupMobileMenuToggle);

Header.mobileSubnavToggle = function(evt) {
  if (evt) {
    evt.preventDefault();
  } else {
    return;
  }

  this.classList.toggle('heading__main-nav-link--subnav-open');
  var subnav = document.querySelector(this.getAttribute("href"));
  subnav.classList.toggle('heading__main-nav-list--shown');
}

Header.setupMobileSubnavs = function() {
  document.querySelectorAll('.js-mobile-subnav-toggle').forEach(function(el) {
    el.addEventListener('click', Header.mobileSubnavToggle);
  })
}

slate.utils.domReady(Header.setupMobileSubnavs);

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    slickContainer: '.product-images__list',
    imageItems: '.product-images__item'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.onVariantChange.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    this.$slickContainer = $(selectors.slickContainer, this.$container);
    if (!this.$slickContainer.hasClass("product-images__list--no-slider")) {
      this.$slickContainer.slick({
        dots: true,
        arrows: false
        // nextArrow: dom_elements.nextArrow,
        // prevArrow: dom_elements.prevArrow
      });
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    onVariantChange: function(evt) {
      this.updateAddToCartState(evt);

      var variant = evt.variant;
      var $imageItems = $(selectors.imageItems);
      $imageItems.each(function() {
        var variantIds = $(this).data('image-variants');
        if (variantIds.indexOf(variant.id) >= 0) {
          $(selectors.slickContainer).slick('slickGoTo', $(this).data('slick-index'));
          return false;
        }
      });
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * Product Showcase Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Showcase section.
 *
 * @namespace showcase
 */

theme.Showcase = (function() {

  var selectors = {
    slickContainer: '.showcase-slider__slider'
  };

  /**
   * Showcase section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Showcase(container) {
    this.$container = $(container);
    this.sectionId = this.$container.attr('data-section-id');
    this.$slickContainer = $(selectors.slickContainer, this.$container);

    var nextArrow = '<button type="button" class="showcase-slider-arrow slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="-7 -11 7 11"><path fill="#00407A" d="M-.97-1.66a1 1 0 1 1-1.5 1.32l-4-4.5a1 1 0 0 1 0-1.32l4-4.5a1 1 0 1 1 1.5 1.32L-4.38-5.5l3.4 3.84z"/></svg><span class="svg-fallback-text">Next</span></button>';
    var prevArrow = '';

    this._unslick = function() {
      console.log('unslick');
      this.$slickContainer.slick('unslick');
    };

    this._slickInit = function() {
      this.$slickContainer = $(selectors.slickContainer, this.$container);

      this.$slickContainer.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        focusOnSelect: true,
        infinite: true,
        centerPadding: '60px',
        mobileFirst: true,
        dots: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 375,
            settings: {
              centerPadding: '80px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 500,
            settings: {
              centerMode: false,
              slidesToShow: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              centerPadding: '40px',
              centerMode: true,
              slidesToShow: 1,
              autoplay: true,
              arrows: true,
              prevArrow: prevArrow,
              nextArrow: nextArrow
            }
          },
          {
            breakpoint: 660,
            settings: {
              centerPadding: '80px',
              centerMode: true,
              slidesToShow: 1,
              autoplay: true,
              arrows: true,
              prevArrow: prevArrow,
              nextArrow: nextArrow
            }
          },
          {
            breakpoint: 750,
            settings: {
              centerMode: false,
              slidesToShow: 2,
              autoplay: true,
              arrows: true,
              prevArrow: prevArrow,
              nextArrow: nextArrow
            }
          },
          {
            breakpoint: 800,
            settings: {
              centerMode: false,
              slidesToShow: 2,
              autoplay: true,
              arrows: true,
              prevArrow: prevArrow,
              nextArrow: nextArrow
            }
          },
          {
            breakpoint: 950,
            settings: {
              centerMode: false,
              slidesToShow: 3,
              autoplay: true,
              arrows: true,
              prevArrow: prevArrow,
              nextArrow: nextArrow
            }
          },
          {
            breakpoint: 1250,
            settings: {
              centerMode: false,
              slidesToShow: 4,
              autoplay: true,
              arrows: true,
              prevArrow: prevArrow,
              nextArrow: nextArrow
            }
          },
          {
            breakpoint: 1500,
            settings: {
              centerMode: false,
              slidesToShow: 5,
              autoplay: true,
              arrows: true,
              prevArrow: prevArrow,
              nextArrow: nextArrow
            }
          },
          {
            breakpoint: 2000,
            settings: {
              centerMode: false,
              slidesToShow: 6,
              autoplay: true,
              arrows: true,
              prevArrow: prevArrow,
              nextArrow: nextArrow
            }
          },
          {
            breakpoint: 2300,
            settings: {
              centerMode: false,
              slidesToShow: 7,
              autoplay: true,
              arrows: true,
              prevArrow: prevArrow,
              nextArrow: nextArrow
            }
          },
          {
            breakpoint: 2560,
            settings: {
              centerMode: false,
              slidesToShow: 8,
              autoplay: true,
              arrows: true,
              prevArrow: prevArrow,
              nextArrow: nextArrow
            }
          }
        ]
      });
    };

    this._slickInit();
  }

  return Showcase;
})();

/**
 * Age Check Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace age_check
 */
theme.AgeCheck = (function() {

	var selectors = {
		submit_birthdate: '#submit_birthdate'
	};
	
	var state = {
		enter_age: false,
		min_age: 19,
		ageCheckIsOpen: false,
		ageVerified: false
	}

	var bodyEl = document.querySelector('body');
	var ageCheckEl;

	/**
   * Age Check section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
	function AgeCheck(container) {
		this.container = container;
		this.namespace = '.age-check';
		ageCheckEl = document.querySelector(this.namespace);
		state.min_age = parseInt(this.container.getAttribute('data-min-age'));

		var enter_age = this.container.getAttribute('data-enter-age');
		if (enter_age !== true || enter_age !== false) {
			if (enter_age === "true") {
				enter_age = true;
			} else {
				enter_age = false;
			}
		}

		state.enter_age = enter_age;


		var submit_birthdate = document.querySelector(selectors.submit_birthdate);

		submit_birthdate.addEventListener('click', submitVerification);

		checkVerifiedCookie();
  }

	function submitVerification() {
		if (state.enter_age) {
			checkAge();
		} else {
			slate.utils.setCookie({
        name: 'age-verified',
        value: true,
        expires: 30
			});
			
			closeAgeCheck();
		}
	}

	function checkAge() {
		var year = parseInt(document.getElementById('byear').value);
		var month = parseInt(document.getElementById('bmonth').value);
		var day = parseInt(document.getElementById('bday').value);
		var theirDate = new Date((year + state.min_age), month, day);
		var today = new Date();

		if ((today.getTime() - theirDate.getTime()) < 0) {
			window.location = 'http://google.com'; //enter domain url where you would like the underaged visitor to be sent to.
		} else {
			slate.utils.setCookie({
        name: 'age-verified',
        value: true,
        expires: 30
			});
			
			closeAgeCheck();
		}
	}

	function openAgeCheck() {
		if (slate.utils.elementExists(ageCheckEl)) {
			ageCheckEl.className += ' age-check--is-open';
			bodyEl.className += ' age-check-is-open';

			slate.a11y.trapFocus({$container: $(ageCheckEl)});
		}
	}

	function closeAgeCheck() {
		if (slate.utils.elementExists(ageCheckEl)) {
			ageCheckEl.className = ageCheckEl.className.replace('age-check--is-open').trim();
			bodyEl.className = bodyEl.className.replace('age-check-is-open').trim();

			slate.a11y.removeTrapFocus({$container: $(ageCheckEl)});
		}
	}

	function checkVerifiedCookie() {
		console.log(!!slate.utils.getCookie('age-verified'));
		if (!slate.utils.getCookie('age-verified')) {
			openAgeCheck();
		} else {
			closeAgeCheck();
		}
	}

	return AgeCheck;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

(function () {
  var cartItems = $(".cart__item");
  var cartTotal = $(".cart__subtotal-money");
  var cartCheckoutButtons = $('.js-checkout-button');
  var cartWineCases = $('.cart-wine-cases');
  var moduloRetries = 0;

  /**
   * Actions for each cart line item in the dom
   */
  cartItems.each(function(cartItemIndex) {
    var lineItem = $(this);
    var quantityInput = lineItem.find(".quanity-actions__number");
    var removeButton = lineItem.find(".js-cart__item-remove");

    quantityInput.change(function() {
      updateItemQuantity(lineItem, +quantityInput.val());
    });

    removeButton.on("click", function(evt) {
      evt.preventDefault();
      updateItemQuantity(lineItem, 0);
    });
  });

  // $(document).ready(function () {
  //   if (window.ZapietEvent) {
  //     window.ZapietEvent.listen('widget.loaded', zapietUpdate);
  //     window.ZapietEvent.listen('checkoutEnabled', zapietUpdate);
  //     window.ZapietEvent.listen('selected_method', zapietUpdate);
  //   }
  // });

  // function zapietUpdate(evt) {
  //   window.setTimeout(function() {
  //     updateCheckoutState(checkWineModulo());
  //   }, 300);
  // }

  /**
   * Updates the quantity of a line item
   * @param {$} lineItem jquery dom element
   * @param {number} quantity The new quantity to set on a product in the cart
   */
  function updateItemQuantity(lineItem, quantity) {
    quantity = +quantity;
    if (typeof quantity != "number") {
      return;
    }

    var lineItemIndex = lineItem.attr("data-item-index");
    var variantId = lineItem.attr("data-variant-id");

    var changePost = slate.cartAjax.changeItemByID(variantId, quantity);

    changePost.done(function() {
      updateCartTotal();
      updateCheckoutState(checkWineModulo());

      if (quantity > 0) {
        // update line item
        updateCartItemTotal(lineItem);
      } else {
        // remove line item
        removeCartItem(lineItem);
      }
    });
  }

  /**
   * Checks if there are a multiple of 3 wines in the cart
   * @returns {boolean} Checkout enabled state
   */
  function checkWineModulo() {
    var wineCount = 0;

    if (slate.cartAjax.hasOwnProperty('cart') && slate.cartAjax.cart.hasOwnProperty('items')) {
      for (var i = 0; i < slate.cartAjax.cart.items.length; i++) {
        if (slate.cartAjax.cart.items[i].product_type === "Wine" || slate.cartAjax.cart.items[i].product_type === "wine") {
          wineCount += slate.cartAjax.cart.items[i].quantity;
        }
      }
  
      if (wineCount > 0) {
        if (wineCount % 3 === 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      // cart ajax hasn't finished, just wait a little then try again
      moduloRetries++;
      if (moduloRetries < 5) {
        window.setTimeout(function() {
          updateCheckoutState(checkWineModulo());
        }, 500);
      }
      return true;
    }
  }

  /**
   * Updates the dom depending on the checkout state
   * @param {boolean} checkoutEnabled Checkout enabled state
   */
  function updateCheckoutState(checkoutEnabled) {
    // cartWineCases

    if (checkoutEnabled) {
      // remove disabled classes and attributes from buttons and change button text
      cartCheckoutButtons
        .removeClass('button--disabled')
        .prop('disabled', false)
        .text(theme.strings.checkout);

      cartWineCases.addClass('hide');
    } else {
      // add disabled classes and attributes from buttons and change button text
      cartCheckoutButtons
        .addClass('button--disabled')
        .prop('disabled', true)
        .text(theme.strings.noCheckout);

      if (cartWineCases.length <= 0) {
        $('.cart__header-info').append('<p class="cart-wine-cases">' + theme.strings.cartCaseMessage + '</p>');
        $('.cart__actions').prepend('<p class="cart-wine-cases">' + theme.strings.cartCaseMessage + '</p>');

        cartWineCases = $('.cart-wine-cases');
      }

      cartWineCases.removeClass('hide');
    }
  }

  /**
   * Updates the cart total price
   */
  function updateCartTotal() {
    cartTotal.html(
      slate.Currency.formatMoney(slate.cartAjax.cart.total_price, theme.moneyFormat)
    );
  }

  /**
   * Updates the line item total price of a given line item
   * @param {$} lineItem jquery dom element
   */
  function updateCartItemTotal(lineItem) {
    /**
     * Get the cart line item dom element
     * find the items line item price
     * get the new line item price from slate.cartAjax.cart
     * change the price in the dom
     */
    var lineItemIndex = lineItem.attr("data-item-index");

    lineItem
      .find(".cart__item-line-price")
      .html(
        slate.Currency.formatMoney(
          slate.cartAjax.cart.items[lineItemIndex].line_price,
          theme.moneyFormat
        )
      );
  }

  /**
   * Animates and removes a cart item from the dom
   * @param {$} lineItem jquery dom element
   */
  function removeCartItem(lineItem) {
    var itemToRemoveIndex = cartItems.index(lineItem);

    if (slate.utils.whichTransitionEvent()) {
      /**
       * add a css class to animate the item out
       * remove the item from the dom
       * call the resetLineItemIndex function
       */
      lineItem
        .addClass("cart__item--remove")
        .one(slate.utils.whichTransitionEvent(), function() {
          lineItem.remove();
          resetLineItemIndex(itemToRemoveIndex);
        });
    } else {
      /**
       * if no transitions are supported
       * remove the item from the dom
       * call the resetLineItemIndex function
       */
      lineItem.remove();
      resetLineItemIndex(itemToRemoveIndex);
    }

    if (slate.cartAjax.cart.item_count < 1) {
      location.reload();
    }
  }

  /**
   * Updates the item-index data attribute on cart line items
   * the item-index data attribute is used for updating line item prices
   * @param {number} indexStart array index number
   */
  function resetLineItemIndex(indexStart) {
    cartItems.each(function(itemIndex) {
      if (itemIndex > indexStart) {
        $(this).attr("data-item-index", itemIndex - 1);
      }
    });
  }
})();

/**
 * Only used for product page layout
 * See scripts/sections/product.js for product/cart code
 */

(function() {
  var dom_elements = {};
  var state = {
    isMobile: false,
    noSlider: false
  };

  var imageItems = [];
  var globalAnimation;
  

  $(document).ready(productPageInit);


  /**
   * Gets the page ready and queries the dom for the need elements
   * Then checks if this is a product page or not
   * If it is then it starts watching the window for resize events and starts the layout functions
   */
  function productPageInit() {
    // dom_elements.product_images_el = document.getElementsByClassName("product-images")[0];
    // dom_elements.product_container_el = document.getElementsByClassName("product-container")[0];
    // dom_elements.product_images_items = document.getElementsByClassName("product-images__item");
    // dom_elements.slick_container = $(".product-images__list");
    dom_elements.$testimonials = $('.testimonials');

    // if (!dom_elements.slick_container.hasClass("product-images__list--no-slider")) {
    //   dom_elements.slick_container.slick({
    //     dots: true,
    //     arrows: false
    //     // nextArrow: dom_elements.nextArrow,
    //     // prevArrow: dom_elements.prevArrow
    //   });
    // }

    // make sure this page has product images
    // if (slate.utils.elementExists(dom_elements.product_images_el)) {
    //   window.addEventListener("load", function() {
    //     slate.utils.onResizeDebounce(productPageResize);
    //   });
    // }

    if (dom_elements.$testimonials.length) {
      dom_elements.$testimonials.slick({
        adaptiveHeight: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 10000,
        pauseOnHover: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        draggable: false
      });
    }
  }


  /**
   * Is called on when the browser is resized
   * Determines the state of the page to decide which layout to use
   */
  // function productPageResize() {
  //   if (slate.utils.viewportWidth < 900) {
  //     // mobile code
  //     if (!state.isMobile) {
  //       pageIsMobile();
  //       state.isMobile = true;
  //     }
  //   } else {
  //     // desktop code
  //     if (state.isMobile) {
  //       if (!state.noSlider) {
  //         dom_elements.slick_container.slick("unslick");
  //       }
  //       state.isMobile = false;
  //     }
  //     pageIsDesktop();
  //   }
  // }



  /**
   * Determines the kind of layout to use based on sizes of product description and image containers
   */
  // function pageIsDesktop() {
  // }


  /** 
   * 
   */
  // function pageIsMobile() {
  //   if (!state.noSlider) {
  //     dom_elements.slick_container.slick({
  //       dots: true,
  //       arrows: false
  //       // nextArrow: dom_elements.nextArrow,
  //       // prevArrow: dom_elements.prevArrow
  //     });
  //   }
  // }
})();

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collectionFilters
 */

theme.collectionFilters = (function() {
  var bodyEl = $('body');

  var openMobileFiltersButton = $('.js-open-mobile-filter'),
    closeMobileFiltersButton = $('.js-close-mobile-filter'),
    applyFiltersButton = $('.js-apply-filters'),
    sortBySelect = $('.js-sort-by'),
    filterLinks = $('.filter-nav__link');

  var state = {
    filterIsMobile: false,
    mobileFilterIsOpen: false
  };

  var newCollection = '';
  var newFilters = '';

  
  /**
   * Creates the mobile collection filters
   */
  function init() {
    if (isCollectionPage()) {
      newCollection = theme.currentCollection.collectionHandle;
      newFilters = theme.currentCollection.currentTags;

      // console.log('is collection page');
      filterLayout();

      slate.utils.getQueryParams();

      if (slate.utils.queryParams.sort_by) {
        sortBySelect[0].value = slate.utils.queryParams.sort_by;
      }
      sortBySelect.on('change', sortCollection);
    }
  }
  

  /**
   * Checks if the current page is a collection page
   * @return {boolean} true if current page is collection
   */
  function isCollectionPage() {
    return bodyEl.hasClass('template-collection') || bodyEl.hasClass('template-index');
  }


  /**
   * Starts watching window resize
   * Checks for filter layout states
   */
  function filterLayout() {
    slate.utils.onResizeDebounce(function() {
			if (slate.utils.viewportWidth >= 900) {
				setDesktopFilters();
			} else {
				setMobileFilters();
			}
		});
  }


  /**
   * Changes the page layout and functionality to work for desktop
   */
  function setDesktopFilters() {
    // if the filter layout is changing from mobile to desktop
    if (state.filterIsMobile || state.mobileFilterIsOpen) {
      closeMobileFilters();
      
      // filterLinks.off('click', filterLinkClick);
    }

    // set the filter layout state
    state.filterIsMobile = false;
  }


  /**
   * Changes the page layout and functionality to work for mobile
   */
  function setMobileFilters() {
    // if the filter layout is already mobile
    if (!state.filterIsMobile) {
      // if the filter state is changing from desktop to mobile
      openMobileFiltersButton.on('click', function(evt) {
        evt.preventDefault();
		    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));

        openMobileFilters();
      });

      closeMobileFiltersButton.on('click', function(evt) {
        evt.preventDefault();

        closeMobileFilters();
      });

      // filterLinks.on('click', filterLinkClick);
    }

    // set the filter layout state
    state.filterIsMobile = true;
  }


  /**
   * Handles the event of clicking on filters when on mobile
   * @param {obj} evt event
   */
  // function filterLinkClick(evt) {
  //   evt.preventDefault();
    
  //   var clickedLink = $(this);
  //   var clickedFilterType = clickedLink.attr('data-filter-type');
  //   var clickedTagHandle = clickedLink.attr('data-tag-handle');

  //   // check if the clickedLink is currently active
  //   if (clickedLink.hasClass('filter-nav__link--active')) {
  //     // if it is active then remove it
  //     clickedLink.removeClass('filter-nav__link--active');
  //   } else {
  //     // if it is not active then make all other filters of the same type inactive and make it active
  //     clickedLink.addClass('filter-nav__link--active');
  //   }

  //   // get the new list of filters
  //   newFilters = updateTags(clickedLink, clickedFilterType);

  //   if (clickedFilterType === 'collection') {
  //     newCollection = clickedLink.attr('data-collection-handle');
  //   }
    
  //   updateApplyButton(buildURL(newCollection, newFilters));
  // }


  /**
   * Gets the updated list of tags based on what the user has slected
   * @param {obj} clickedLink The jquery dom element for the link that is clicked
   * @param {string} clickedFilterType The type of filter that was clicked
   * @return {array} new array of tag handles
   */
  // function updateTags(clickedLink, clickedFilterType) {

  //   var newTags = [];

  //   filterLinks.each(function() {
  //     var nextLink = $(this);
  //     var nextLinkFilterType = nextLink.attr('data-filter-type');

  //     // unless this link is the link that was clicked
  //     if (clickedLink[0] !== nextLink[0]) {
  //       // if this link is the same type of link as the one clicked
  //       if (clickedFilterType === nextLinkFilterType) {
  //         nextLink.removeClass('filter-nav__link--active');
  //       }
  //     }

  //     // if this link is currently active add it to the list of
  //     if (nextLink.hasClass('filter-nav__link--active')) {
  //       if (nextLinkFilterType !== 'collection') {
  //         newTags.push(nextLink.attr('data-tag-handle'));
  //       }
  //     }
  //   });

  //   return newTags;
  // }


  /**
   * Takes a collection handle and list of tags and builds a url for them
   * @param {string} collection collection handle
   * @param {array} tags array of strings of tags
   * @return {string} new filter URL
   */
  // function buildURL(collection, tags) {
  //   var url = '';
  //   var filterString = '';

  //   if (tags.length) {
  //     for (var i = 0; i < tags.length; i++) {
  //       if (i === 0) {
  //         filterString = filterString + tags[i];
  //       } else {
  //         filterString = filterString + '+' + tags[i];
  //       }
  //     }
  //   }
    
  //   url = '/collections/' + collection + '/' + filterString;
  //   return url;
  // }


  /**
   * Updates the href attribute on the mobile applyFiltersButton
   * @param {string} url 
   */
  // function updateApplyButton(url) {
  //   if (url.length <= 0) {
  //     url = theme.currentCollection.currentFilterURL;
  //   }

  //   // if the collection was changed just ignore the passed in url
  //   if (newCollection !== theme.currentCollection.collectionHandle) {
  //     url = '/collections/' + newCollection;
  //   }
  //   applyFiltersButton.attr('href', url);
  // }


  /**
   * Opens the mobile filter
   */
  function openMobileFilters() {
    bodyEl.addClass('collection-filter--open');
    state.mobileFilterIsOpen = true;
  }


  /**
   * Closes the mobile filter
   */
  function closeMobileFilters() {
    bodyEl.removeClass('collection-filter--open');
    state.mobileFilterIsOpen = false;
  }


  /**
   * A function that gives the state of the filter layout
   * @return {obj} 
   */
  function getState() {
    return {
      filterIsMobile: state.filterIsMobile,
      mobileFilterIsOpen: state.mobileFilterIsOpen
    };
  }


  /**
   * Handles collection sort changes
   */
  function sortCollection() {
    slate.utils.queryParams.sort_by = $(this)[0].value;
    window.location.search = $.param(slate.utils.queryParams).replace(/\+/g, '%20');
  }

  return {
    init: init,
    state: getState,
    openMobileFilters: openMobileFilters,
    closeMobileFilters: closeMobileFilters
  };
})();
(function () {
  var quickAddButtons = document.getElementsByClassName('js-quick-add-to-cart');
  var bodyEl = document.getElementsByTagName('body')[0];
  var successPopup = document.getElementById('quick-add-success');

  // Check if quick add buttons exist on this current page
  if (slate.utils.elementExists(quickAddButtons[0])) {
    initQuickAdd();
  }

  /**
   * Initialize the quick add buttons
   */
  function initQuickAdd() {
    for (var i = 0; i < quickAddButtons.length; i++) {
      quickAddButtons[i].addEventListener('click', quickAddClick);
    }
  }

  /**
   * Handle the click event on quick add buttons
   * @param {event} evt 
   */
  function quickAddClick(evt) {
    evt.preventDefault();
    bodyEl.className += ' ajax-in-progress';

    var addItem = slate.cartAjax.addToCart(+this.getAttribute('data-variant-id-value'), 1);

    addItem.done(function () {
      // show success mesage
      bodyEl.className += ' ajax-success';

      setTimeout(function () {
        showPopup();
      }, 1000);

      function showPopup() {
        bodyEl.className = bodyEl.className.replace('ajax-success', 'ajax-success--hide').trim();
        if (slate.utils.whichTransitionEvent() !== undefined) {
          successPopup.addEventListener(slate.utils.whichTransitionEvent(), hidePopup);
        } else {
          setTimeout(function () {
            hidePopup();
          }, 500);
        }
      }
      function hidePopup() {
        successPopup.removeEventListener(slate.utils.whichTransitionEvent(), hidePopup);
        bodyEl.className = bodyEl.className.replace('ajax-success--hide', '');
        bodyEl.className = bodyEl.className.replace('ajax-in-progress', '').trim();
      }
    });
  }
})();
(function() {
  var skipLinks = document.querySelectorAll('.js-visit-link');

  for (var i = 0; i < skipLinks.length; i++) {
    skipLinks[i].addEventListener('click', skipLinkClick);
  }

  function skipLinkClick(evt) {
    evt.preventDefault();

    $([document.documentElement, document.body]).animate({
      scrollTop: $(evt.currentTarget.hash).offset().top
    }, 1000);
  }



  var faqLinks = document.querySelectorAll('.js-faq-question');

  for (var j = 0; j < faqLinks.length; j++) {
    faqLinks[j].addEventListener('click', faqLinkClick);
  }

  function faqLinkClick(evt) {
    evt.preventDefault();

    var answer = document.querySelector(this.getAttribute('href'));

    if (this.getAttribute('aria-expanded') === 'false') {
      this.setAttribute('aria-expanded', true);

      answer.className += ' visit-faq__description--open';
    } else {
      this.setAttribute('aria-expanded', false);

      answer.className = answer.className.replace(/visit-faq__description--open/, '').trim();
    }
    
  }
})();
(function() {
  var bioToggles = document.querySelectorAll('.js-bio-toggles');

  for (var j = 0; j < bioToggles.length; j++) {
    bioToggles[j].addEventListener('click', bioToggleClick);
  }

  function bioToggleClick(evt) {
    evt.preventDefault();

    var bio = document.querySelector(this.getAttribute('href'));

    if (this.getAttribute('aria-expanded') === 'false') {
      this.setAttribute('aria-expanded', true);

      bio.className += ' TeamBios__Bio--open';
    } else {
      this.setAttribute('aria-expanded', false);

      bio.className = bio.className.replace(/TeamBios__Bio--open/, '').trim();
    }
    
  }
})();
(function() {
  var sliders = $('.js-image-text-slider');
  var sliderPrev = $('.js-slider-prev');
  var sliderNext = $('.js-slider-next');

  sliders.slick({
    infinite: true,
    dots: false,
    arrows: false,
    adaptiveHeight: true
  });
  
  sliders.on('afterChange', function(evt, slick, currentSlide) {
    $('#slider-count--' + slick.$slider.attr('data-section-id')).html((currentSlide+1) + ' / ' + slick.slideCount)
  });

  sliderPrev.on('click', function(evt) {
    var slider = $('.js-image-text-slider--' + $(this).attr('data-section-id'));
    slider.slick('slickPrev');
  });

  sliderNext.on('click', function(evt) {
    var slider = $('.js-image-text-slider--' + $(this).attr('data-section-id'));
    slider.slick('slickNext');
  });
})();

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('header-section', theme.Header);
  sections.register('showcase-slider', theme.Showcase);
  sections.register('age-check', theme.AgeCheck);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $("a[href^='#']:not([class*='js-'])").on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  if (!slate.utils.supportsSVG()) {
    $('html').addClass('no-svg');

    $('img').each(function (n, node) {
      var src = node.src;
      node.src = src.replace('.svg', '.png');
    });
  }

  // if (slate.utils.supportsBackgroundBlendMode()) {
  //   $('html').addClass('blendmode');
  // } else {
  //   $('html').addClass('no-blendmode');
  // }

  // check if proxima nova has already been downloaded
  if (!slate.utils.getCookie('proxima-nova-loaded')) {
    // create a new FontFaceObserver to watch for proxima nova to download
    var fontProxima = new FontFaceObserver("proxima-nova");

    fontProxima.load().then(function () {
      document.documentElement.className += " proxima-nova-loaded";
      slate.utils.setCookie({
        name: 'proxima-nova-loaded',
        value: true,
        expires: 100
      });
    });
  }

  // check if lakeside has already been downloaded
  if (!slate.utils.getCookie('clavo-loaded')) {
    // create a new FontFaceObserver to watch for lakeside to download
    var fontLakeside = new FontFaceObserver("clavo");

    fontLakeside.load().then(function () {
      document.documentElement.className += " clavo-loaded";
      slate.utils.setCookie({
        name: 'clavo-loaded',
        value: true,
        expires: 100
      });
    });
  }

  $(window).on('resize', function () {
    slate.utils.setViewportSize();
  });

  theme.collectionFilters.init();

  // get the cart data through the ajax api
  slate.cartAjax.getCart();

  var cartCount = document.getElementById('cart-item-count');
  var reviewCartCount = document.getElementById('review-cart-item-count');

  // watch for new cart data
  $(document).on('cartUpdated', function() {
    // update cart count badge
    if (slate.utils.elementExists(cartCount)) {
      if (slate.cartAjax.cart.item_count <= 0) {
        cartCount.className += ' cart-item-count--zero';
      } else {
        cartCount.className = cartCount.className.replace(/cart-item-count--zero/g, '').trim();
      }
      cartCount.innerHTML = slate.cartAjax.cart.item_count;

      if (slate.utils.elementExists(reviewCartCount)) {
        reviewCartCount.innerHTML = slate.cartAjax.cart.item_count;
      }
      cartCount.className += ' cart-item-count--pulse';
      setTimeout(function () {
        cartCount.className = cartCount.className.replace(/cart-item-count--pulse/g, '').trim();
      }, 600);
    }
  });

  // qunaitity input
  $('.quanity-actions').each(function () {
    var input = $(this).find('.quanity-actions__number');
    var add = $(this).find('.quanity-actions__button--add');
    var minus = $(this).find('.quanity-actions__button--minus');

    add.on('click', function () {
      input.val(+input.val() + 1);
      input.change();
    });
    minus.on('click', function () {
      input.val((+input.val() > 1) ? +input.val() - 1 : 1);
      input.change();
    });
  });

  $('.filter-nav__trigger').click(function () {
    $(this)
      .toggleClass('filter-nav__trigger-open')
      .siblings('.filter-nav__list')
      .toggleClass('filter-nav__list--open');
  });



  var animatedLogo = document.querySelector('.logo-breakdown');

  function activateLogo() {
    if (slate.utils.viewportWidth >= 768) {
      var scroll_top = document.body.scrollTop || document.documentElement.scrollTop;
      var window_height = isNaN(window.innerHeight) ? window.clientHeight : window.innerHeight;

      var element_offset = animatedLogo.offsetParent.offsetTop + animatedLogo.offsetTop + 200;

      if ((scroll_top + window_height) > (element_offset) && ((element_offset + animatedLogo.offsetHeight) > scroll_top)) {
        animatedLogo.className += ' activated';
      }
    }
  }

  if (slate.utils.elementExists(animatedLogo)) {
    activateLogo();

    document.addEventListener('scroll', function(evt) {
      if (animatedLogo.className.indexOf('activated') <= 0) {
        activateLogo();
      }
    });
  }
});